// extracted by mini-css-extract-plugin
module.exports = {"two-columns-layout":"two-columns-layout___Oeo3"};